import { useNavigate } from 'react-router-dom';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import { LEGAL_PROCEEDINGS_EDIT } from '../../../../../../routes/paths';
import EditIcon from '@mui/icons-material/Edit';
import { LegalProceedingsDetailActionsProps } from './props';

export const LegalProceedingsDetailActions = ({
    legalProceedingId,
}: LegalProceedingsDetailActionsProps) => {
    const navigate = useNavigate();
    const textBtnStyle = {
        display: {
            xs: 'none',
            lg: 'block',
        },
    };

    const btnIconStyle = { marginRight: { xs: -1, lg: undefined } };

    return (
        <>
            <LoadingButtonGeneral
                variant="outlined"
                title="Editar"
                sx={{ mr: 1 }}
                onClick={() =>
                    navigate(`${LEGAL_PROCEEDINGS_EDIT}/${legalProceedingId}`)
                }
                startIcon={<EditIcon sx={btnIconStyle} />}
                textSx={textBtnStyle}
            />
        </>
    );
};
